<template>
    <div>
        <input :id="id" :value="value" :listening="fullData"></input>
    </div>
</template>

<script>
    import mobiscroll from '@mobiscroll/javascript'
    import axios from 'axios'
    import _ from 'lodash'

    export default {

        props: {
            remoteFilter: {
                type: [String, Number, Boolean],
                default: false
            },
            edited: {
                type: String,
                default: 0,
                required: true
            },
            value: {
                default: null
            },
            item: {
                type: Object,
                required: true
            },
            fullData: {
                type: Object,
                required: true
            }
        },

        computed: {
            selectedQuery(){
                if(!!this.item.fieldOptions.dependsOn){
                    return axios.defaults.baseURL  + '/' + this.item.fieldOptions.origin + '/' + this.fullData[this.item.fieldOptions.dependsOn] + '/' 
                } else {
                    return axios.defaults.baseURL + '/' + this.item.fieldOptions.origin + '/'
                }
            }
        },

        methods: {
            reviewDependants(){
                if(!!this.item.fieldOptions.dependsOn){
                    this.dependsOn = this.item.fieldOptions.dependsOn
                    this.dependingStatus = _.clone(this.fullData[this.dependsOn])
                }
            },
            updateOptions(){
                this.inst.clear()
                this.initialize()
            },
            initialize(){
                this.inst = mobiscroll.select('#' + this.id, {
                    display: 'inline',
                    filter: true,
                    inputClass: 'form-control',
                    multiline: 2,
                    data: {
                        url: this.selectedQuery,
                        remoteFilter: this.remoteFilter,
                        type: 'json',
                        processResponse: (response) => {
                            this.availableOptions = response.data
                            return response.data
                        }
                    },
                    onSet:(event, inst) => {
                        this.$emit('input', inst.getVal())
                    }
                })
            }
        },

        data: () => {
            return {
                id: null,
                dependingStatus: null,
                dependsOn: null,
                inst: null,
                availableOptions: []
            }
        },

        watch: {
            edited(){
                if(this.dependingStatus != this.fullData[this.dependsOn]){
                    this.dependingStatus = this.fullData[this.dependsOn]
                    this.updateOptions()
                }
            }
        },

        beforeMount(){
            this.id = _.uniqueId('fk-select-')
        },

        mounted(){
            this.reviewDependants()
            this.initialize()
        }
    }
</script>

<style lang="less">

.mbsc-sel-filter-show-clear {
  position: absolute;
  right: 0;
  opacity: 0.25;
}

</style>